<div class="chart-container">
  <div [id]="chartId" class="chartdiv"></div>
  @if (dataIsLoading) {
    <div class="loading-overlay" data-testid="loading-overlay">Loading...</div>
  }
</div>
